module.exports = __webpack_public_path__ + "img/loyalty-program-d.f115414.webp";